import {StorageKey, getStorage, setStorage} from './storage';
import {commonConfig, formTitleCfg, momentFormat, tlcConfig} from "../config/common";
import {messageHdl} from "./messageHdlr";
import {system, meeting} from "../server";

const unitSlotMinute = commonConfig.unitSlotMinute;  // 30
// const slotProximityMin = {
//   sm: parseInt(unitSlotMinute / 3),  // 10
//   lg: parseInt(unitSlotMinute / 3) * 2,  // 20
// };

// 根据slot获取具体日期时间 => date
export function getDateBySlot(slot, date) {
  const thisDateStart = moment(date).startOf('day');
  // console.log(thisDateStart.format(momentFormat.dateTimeDetail))
  return thisDateStart.add(slot * unitSlotMinute, 'minutes').toDate();
}

// 根据slot获取具体时间点 => string
export function getTimeBySlot(timeSlot) {
  if (!timeSlot && timeSlot != 0) return null;
  const curTime = getDateBySlot(timeSlot);
  return moment(curTime).format(momentFormat.time)
}

// 根据date获取slot => number
export function getSlotByDate(date, ceil = true) {
  if (!date) return;
  try {
    const hour = date.getHours();
    const minute = date.getMinutes();
    // console.log({hour, minute});
    return hour * 2 + (ceil ? Math.ceil(minute / unitSlotMinute) : Math.floor(minute / unitSlotMinute))
  } catch (e) {
    console.log(e);
    return null
  }
}

// 根据slot获取具体日期时间 => date
export function getDateByUnitMinutes(slot, unitMinutes) {
  const thisDateStart = moment().startOf('day').toDate();
  return moment(thisDateStart).add(slot * unitMinutes, 'minutes').toDate();
}

// 根据slot获取具体时间点 => string
export function getTimeByUnitMinutes(timeSlot, unitMinutes) {
  if (!timeSlot) return null;
  const curTime = getDateByUnitMinutes(timeSlot, unitMinutes);
  return moment(curTime).format(momentFormat.time)
}

// 根据date获取slot => number
export function getUnitMinutesByDate(date, unitMinutes) {
  if (!date) return;
  try {
    const hour = date.getHours();
    const minute = date.getMinutes();
    return hour * (60 / unitMinutes) + (minute / unitMinutes)
  } catch (e) {
    console.log(e);
    return null
  }
}

// 判断是否是同一天
export function isOnTheSameDay(start, end) {
  if (!start || !end) return false;
  return moment(start).format(momentFormat.date) === moment(end).format(momentFormat.date);
}

// 根据time获取slot => number
export function getUnitMinutesByTime(time, unitMinutes) {
  if (!time) return;
  try {
    const timeList = time.split(":");
    return parseInt(timeList[0]) * (60 / unitMinutes) + (parseInt(timeList[1]) / unitMinutes)
  } catch (e) {
    console.log(e);
    return null
  }
}

// 获取会议预约的初始默认时间，下一预约时间单元
export function getDefaultTime(unit) {
  const cTime = moment().add(1, 'm').toDate();
  const minutes = cTime.getMinutes();
  const unitMinutes = unit || getStorage(StorageKey.unitMinutes, true);
  // const unitMinutes = 5;
  const remainder = minutes % unitMinutes;
  // console.log(remainder)
  if (remainder === 0) return moment(cTime).toDate();
  return moment(cTime).add(unitMinutes - remainder, 'm').toDate()
  /*
  const minTime = minSlot && moment(getDateBySlot(minSlot));
  if (minTime && minTime.diff(moment(cTime), 'm') > 1) {
    return minTime.toDate();
  }
  let destTime;
  if (minutes < unitSlotMinute) {
    if ((unitSlotMinute - minutes) > slotProximityMin.sm) {
      destTime = moment(cTime).startOf('hour');
    } else {
      destTime = moment(cTime).add(unitSlotMinute - minutes, 'minutes');
    }
  } else {
    if ((minutes - unitSlotMinute) > slotProximityMin.lg) {
      destTime = moment(cTime).add(1, 'hour').startOf('hour');
    } else {
      destTime = moment(cTime).subtract(minutes - unitSlotMinute, 'minutes');
    }
  }
  return destTime.toDate()
  */
}

// 将分钟转换为 xx天xx小时xx分钟
export function formatMinToNtcTime(time) {
  let durationCN = "";
  const wholeHours = Math.floor(time / 60);
  const days = Math.floor(wholeHours / 24);
  const hours = wholeHours % 24;
  const minutes = time % 60;
  days && (durationCN = days + '天');
  hours && (durationCN += hours + '小时');
  minutes && (durationCN += minutes + '分钟');
  return durationCN
}

// 通过开始&结束时间，获取会议室占用的slots（30分钟一个单位）
export function getReservedSlotsByTime({date, reservedTime}) {
  if (!reservedTime || !reservedTime.length) return [];
  // console.log({reservedTime})
  const slots = [];
  const curDay = moment(date).toDate().getDate();
  reservedTime.forEach(ele => {
    const {start, end} = ele;
    const startDate = new Date(start);
    const endDate = new Date(end);
    let startSlot = getSlotByDate(startDate.getDate() === curDay ? startDate
      : moment(date).startOf('d').toDate(), false);
    let endSlot = getSlotByDate(endDate.getDate() === curDay ? endDate
      : moment(date).endOf('d').toDate());
    while (startSlot < endSlot) {
      slots.push(startSlot++);
    }
  });
  // console.log(slots)
  return [...(new Set(slots))]
}

// 从日程预约，获取当前选择的日期作为预约的时间  call this
export function setSchReserveDate(selectedDate, rtn) {
  const diff = moment(selectedDate).diff(moment().startOf('day'), 'day');
  let startTime;
  if (diff) {
    startTime = moment(selectedDate).startOf('day').add(commonConfig.startHour, 'h').toDate();
  } else {
    startTime = getDefaultTime()
  }
  if (rtn) return startTime;
  this.$store.commit('setReserveInfo', {startTime: startTime});
}

export function getUserInfo() {
  return {
    userId: getStorage(StorageKey.userId),
    token: getStorage(StorageKey.token),
  }
}

/*
export function clearGraphqlCache() {
  // 清除缓存
  // return await apolloClient.clearStore();
  apolloClient.cache.reset()
}
*/

export function checkRespCorrect(resp, errStr) {
  window.UIBlock && UIBlock.unblock();  // admin
  window.UILoader && UILoader.unload();  // front
  if (resp.code === 0) return true;
  if (errStr) {
    messageHdl.call(this, {msg: resp.errMsg || errStr});
  }
}

export function confirmMessage(info, handleFunc = (...args) => false) {
  this.$confirm(info.content, info.title || '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: info.type || 'warning'
  }).then(() => {
    handleFunc();
  }).catch(() => {
  })
}

export function confirmMultiMessages(arr, finalFunc = (...args) => false) {
  if (arr.length) {
    const tip = arr.shift();
    confirmMessage.call(this, {content: tip}, () => {
      confirmMultiMessages.call(this, arr, finalFunc)
    })
  } else {
    finalFunc()
  }
}

export function frontConfirm(info, handleFunc = (...args) => false) {
  window.vtDialog && vtDialog.confirm({
    title: info.title || '提示',
    message: info.msg,
  }).then(() => {
    // on confirm
    handleFunc(true)
  }).catch(() => {
    // on cancel
    info.withCancel && handleFunc(false)
  });
}

export function frontMultiConfirm(info, arr, finalFunc = (...args) => false) {
  if (arr.length) {
    const tip = arr.shift();
    frontConfirm({
      title: info.title || "提交确认",
      msg: tip,
      withCancel: info.withCancel
    }, (res) => {
      if (info.withCancel) {
        res && frontMultiConfirm(info, arr, finalFunc);
        return
      }
      frontMultiConfirm(info, arr, finalFunc)
    })
  } else {
    finalFunc()
  }
}

// 刷新防抖动
export function refreshDebounce(refreshTime) {
  const diff = moment(new Date()).diff(moment(refreshTime), 's');
  return diff <= 5
}

// 判断是否是企业微信浏览器
export function checkIsWXWork() {
  // return true
  return navigator.userAgent.includes(commonConfig.wxwork)
}

// 判断是否是微信浏览器
export function checkIsWeChat() {
  // return true
  return navigator.userAgent.includes(commonConfig.weChat)
}

// 判断是否是手机端访问
export function checkIsMobile() {
  return navigator.userAgent.toLowerCase().includes('mobile')
}

export function initAfterLogin(resp) {
  const {userId, token, user = {}} = resp;
  setStorage(StorageKey.userId, userId);
  setStorage(StorageKey.username, user.name);
  setStorage(StorageKey.userProfile, user);
  setStorage(StorageKey.token, token);
  setStorage(StorageKey.tokenExpiresAt, moment().add(1, 'day').endOf('day').valueOf());
}

// 根据key查询视频会议信息
export async function queryTlcInfoByKey(keys, mid) {
  try {
    const data = {
      mid: mid,
      keys: keys
    }
    const {searchTlcInfo: res} = await meeting.queryTlcInfo(this, {queryFilter: data});
    if (res.code === 0) {
      return res.data || {}
    }
    return {};
  } catch (err) {
    throw new Error(err);
  }
}

export function syncHandle(func) {
  let timer = setTimeout(async () => {
    await func();
    clearTimeout(timer);
  }, 0);
}

// call this
export function initSysView(cb) {
  system.querySysView(this).then(({querySystemView: resp = {}}) => {
    if (checkRespCorrect(resp)) {
      if (resp.data) {
        if (this.$store) {
          const {logoUrl, icoUrl, mgrResourceUrl: mgrSrcUrl, siteTile, formTitleList} = resp.data;
          const sysView = {
            logoUrl: mgrSrcUrl && logoUrl ? (mgrSrcUrl + logoUrl) : "",
            icoUrl: mgrSrcUrl && icoUrl ? (mgrSrcUrl + icoUrl) : "",
            mgrSrcUrl,
            siteTile
          };
          const formTitles = {...formTitleCfg.basicTitles};
          const requiredFields = {};
          (formTitleList || []).forEach(ele => {
            if (ele.label && ele.value) {
              if (ele.isRequired) {
                requiredFields[ele.value] = true
              }
              formTitles[ele.value] = ele.label
            }
          });
          // console.log(formTitles);
          // console.log(requiredFields);
          setStorage(StorageKey.sysView, sysView);
          // 用于替换 document title
          setStorage(StorageKey.roomTitle, formTitles.meetingRoom);
          this.$store.commit('setSysView', {
            sysView,
            formTitles,
            requiredFields,
            functions: resp.data.functions,
          });
          appendFavicon(this.$store.state.sysView.icoUrl);
        }
      }
      cb && cb(resp.data)
    }
  }).catch(err => {
  })
}

// call this
export function initSysConfig(handleFunc = (...args) => false) {
  // 以防页面在 StorageKey.userId 未赋值前先获取了 userId
  this.$store.commit('setUserId', getStorage(StorageKey.userId));

  system.queryConfig(this).then(({querySystemConfig: resp = {}}) => {
    if (checkRespCorrect(resp)) {
      setStorage(StorageKey.unitMinutes, resp.unitMinutes || 15);
      setStorage(StorageKey.sysConfig, resp || {});
      this.$store.commit('setSysConfig', resp);
    }
    handleFunc()
  }).catch(err => {
    handleFunc()
  })
}

export function formatRootPath(path) {
  return process.env.NODE_ENV === 'production' ? commonConfig.pathMap[path] : path + '.html'
}

// 格式化会议时间
export function formatMeetTime(meeting, date) {
  const minTime = moment(new Date(date)).startOf('day').toDate().valueOf();
  const maxTime = moment(new Date(date)).endOf('day').toDate().valueOf();
  let startTime = '';
  let endTime = '';
  if (meeting.startTime < minTime) {
    startTime = '00:00';
  } else {
    startTime = moment(meeting.startTime).format(momentFormat.time);
  }
  if (meeting.endTime > maxTime) {
    endTime = '24:00';
  } else {
    endTime = moment(meeting.endTime).format(momentFormat.time);
  }
  return `${startTime}-${endTime}`;
}

// 格式化会议列表
export function formatMListDoc(ele, vueSelf, thisDate) {
  const {meetingStatus, meetingTypes} = vueSelf.$store.state;
  const mDoc = {
    ...ele.meeting,
    mid: ele.cursor,
  };
  const tlcInfo = mDoc.teleconferenceInfo || {};

  let meetingTime = "";
  if (thisDate) {
    meetingTime = formatMeetTime(mDoc, thisDate);
  }

  let duration = moment(mDoc.endTime).diff(moment(mDoc.startTime), 'm')

  return {
    ...mDoc,
    dateTime: moment(mDoc.startTime).format(momentFormat.dateFormatDayCN),
    dateDay: moment(mDoc.startTime).format(momentFormat.dateFormatDay),
    shortDate: moment(mDoc.startTime).format(momentFormat.shortDate),
    meetingTime: meetingTime || `${moment(mDoc.startTime).format(momentFormat.time)}-${moment(mDoc.endTime).format(momentFormat.time)}`,
    applyEndTime: moment(mDoc.applyEndTime).format(momentFormat.datetime),
    duration: duration,
    durationCN: formatMinToNtcTime(duration),
    weekDay: "周" + commonConfig.weekInfo[new Date(mDoc.startTime).getDay()],
    statusCN: meetingStatus[mDoc.status],
    typeCN: meetingTypes[mDoc.meetingType],
    statusStyle: commonConfig.statusStyle[mDoc.status],
    // type: globalString.ZH.meetingString.types[mDoc.type],
    // deviceRequire: (mDoc.deviceRequire || []).join('；'),
    meetingRoom: _.pluck(mDoc.meetingRooms, "roomNum").join('；'),
    sponsorName: mDoc.sponsor && mDoc.sponsor.name,
    initiatorName: mDoc.initiator && mDoc.initiator.name,
    createdBy: mDoc.reservedBy && mDoc.reservedBy.name,
    isCheckin: mDoc.checkinInfo && mDoc.checkinInfo.date,  // 会议是否签到
    conferenceNum: tlcInfo.conferenceNum,
    tlcManufacturer: tlcInfo.manufacturer,
    fromNow: moment(mDoc.startTime).fromNow(),
    hasService: mDoc.service && (mDoc.service.specificContent || (mDoc.service.quickDemands || []).length),
    mode: commonConfig.meetingModes[mDoc.meetingMode] || '',
    participantNumber: mDoc.insideParticipant.length + mDoc.outsideParticipant.length,
    reserveWayCN: commonConfig.reserveWays[mDoc.reserveWay] && commonConfig.reserveWays[mDoc.reserveWay].label || mDoc.reserveWay
  }
}

export function formatMtDetail(mDoc, vueSelf, mgrUrl) {
  if (!mDoc) return {};
  const {meetingStatus, meetingTypes} = vueSelf.$store.state;

  const {meetingRooms = [], cancelInfo, checkinInfo, teleconferenceInfo, service, releaseInfo} = mDoc;
  // if (!meetingRooms.length) return {};
  const [firstRoom] = meetingRooms;
  const timeMm = {
    start: moment(mDoc.startTime),
    end: moment(mDoc.endTime),
  };
  const timeInfo = {
    startDate: timeMm.start.format(momentFormat.dateFormatDayCN),
    endDate: timeMm.end.format(momentFormat.dateFormatDayCN),
    startTime: timeMm.start.format(momentFormat.time),
    endTime: timeMm.end.format(momentFormat.time),
    duration: timeMm.end.diff(timeMm.start, 'm')
  };
  let services = [];
  if (service) {
    services = (service.quickDemands || []).map(e => `${e.type} ${e.amount}${e.unit || '份'}`);
    service.specificContent && services.push(service.specificContent)
  }
  const {total: mtTotalCost, room: roomCost} = mDoc.meetingCost || {};
  return {
    ...mDoc,
    ...timeInfo,
    applyEndTime: moment(mDoc.applyEndTime).format(momentFormat.datetime),
    durationCN: formatMinToNtcTime(timeInfo.duration),
    weekDay: "周" + commonConfig.weekInfo[new Date(mDoc.startTime).getDay()],
    roomId: firstRoom && firstRoom.roomId,
    roomName: firstRoom && firstRoom.name,
    roomNum: firstRoom && firstRoom.roomNum,
    roomPics: mgrUrl && firstRoom && firstRoom.pictures.map(e => mgrUrl + e.url) || [],
    statusCN: meetingStatus[mDoc.status],
    statusStyle: commonConfig.statusStyle[mDoc.status],
    typeCN: meetingTypes[mDoc.meetingType],
    meetingModeCN: commonConfig.meetingModes[mDoc.meetingMode],
    participants: mDoc.insideParticipant || [],
    visitors: _.pluck(mDoc.outsideParticipant, 'name').join('、'),
    ccUsers: _.pluck(mDoc.copyToUsers, 'name').join('、'),
    cancelReason: cancelInfo && cancelInfo.reason,
    ...(checkinInfo ? {
      checkinDate: moment(checkinInfo.date).format(momentFormat.dateFormatMonthDetailCN),
      checkinBy: checkinInfo.operator && checkinInfo.operator.name
    } : {}),
    conferenceNum: teleconferenceInfo && teleconferenceInfo.conferenceNum,
    tlcManufacturer: teleconferenceInfo && teleconferenceInfo.manufacturer,
    serviceDmd: services.join('；'),
    seatsArgLen: firstRoom && firstRoom.seatsArrangement && firstRoom.seatsArrangement.length,
    sponsorName: mDoc.sponsor && mDoc.sponsor.name,
    sponsorDeptNames: (mDoc.sponsor && mDoc.sponsor.deptNames || []).join('、'),
    initiatorName: mDoc.initiator && mDoc.initiator.name,
    initiatorDeptNames: (mDoc.initiator && mDoc.initiator.deptNames || []).join('、'),
    createdBy: mDoc.reservedBy && mDoc.reservedBy.name,
    // reservedDeptNames: (mDoc.reservedBy && mDoc.reservedBy.deptNames || []).join('、'),
    serviceSumPrice: (service && service.quickDemands || []).reduce((sum, ele) => {
      return sum + (ele.amount && ele.price ? ele.amount * ele.price : 0)
    }, 0),
    deviceExceptionTip: firstRoom && firstRoom.deviceExceptionTip,
    lvcViewUrl: mDoc.liveConferenceInfo && mDoc.liveConferenceInfo.viewUrl,
    extensionFields: mDoc.extensionFieldJSON && JSON.parse(mDoc.extensionFieldJSON),
    periodicTypeCN: mDoc.isPeriodic && mDoc.periodicInfo
      && (commonConfig.periodicTypes[mDoc.periodicInfo.periodicType] || {}).label || "",
    periodicUtDate: mDoc.isPeriodic && mDoc.periodicInfo
      && moment(mDoc.periodicInfo.untilDate).format(momentFormat.dateFormatDayCN),
    branchVenueNames: mDoc.branchVenues && mDoc.branchVenues.map(e => e.name).join('、'),
    releaseTextInfo: releaseInfo && releaseInfo.operator && (releaseInfo.operator.name + " 于" + moment(releaseInfo.date).format(momentFormat.dateFormatDetailCN) + " 释放会议"),
    mtTotalCost: mtTotalCost || 0,
    roomCost: roomCost || 0,
    meetingGrade: mDoc.meetingGrade,
    timeRange: mDoc.timeRange,
  }
}

export function sortMeeting(a, b) {
  if (b.status === a.status) {
    return a.startTime - b.startTime
  }
  return commonConfig.statusSort[b.status] - commonConfig.statusSort[a.status]
}

// 视频会议厂家编号
export function formatTlcConferenceNum(num) {
  if (num) {
    if (Number.isNaN(Number(num))) return num;  // 非纯数字，直接返回
    const numLen = String(num).length;
    if (numLen < 6) return num + "";
    const conferenceNumArr = String(num).split('');
    numLen > 10 && conferenceNumArr.splice(9, 0, '-');
    numLen > 7 && conferenceNumArr.splice(6, 0, '-');
    conferenceNumArr.splice(3, 0, '-');
    return conferenceNumArr.join('')
  }
  return ""
}

// 格式化视频会议相关信息
export function formatTlcInvitation(mDoc) {
  const date = moment(mDoc.startTime).format(momentFormat.dateFormatDayCN);
  const time = `${moment(mDoc.startTime).format(momentFormat.time)}-${moment(mDoc.endTime).format(momentFormat.time)}`;
  const apm = (new Date(mDoc.startTime)).getHours() > 12 ? "下午" : "上午";
  const tlcInfo = mDoc.teleconferenceInfo || {};

  const {tlcMFSettings} = getStorage(StorageKey.sysConfig, true) || {};
  const attendMode = (tlcMFSettings.find(e => e.manufacturer === tlcInfo.manufacturer) || {}).attendMode || "";

  // const cTlcNotice = tlcConfig.invitation[tlcInfo.manufacturer || tlcConfig.manufacturers.zoom];
  const cTlcNotice = tlcConfig.invitation[tlcInfo.manufacturer || tlcConfig.manufacturers.xyLink];
  // 影响格式，不要更改缩进
  return cTlcNotice && `${cTlcNotice.title}会议
  会议主题： ${mDoc.subject}
  会议编号： ${formatTlcConferenceNum(tlcInfo.conferenceNum)}
  会议密码： ${tlcInfo.password || '无'}
  会议时间： ${date} ${time} ${apm} Asia/Shanghai
  ${tlcInfo.manufacturer === tlcConfig.manufacturers.xyLink ? "" : `会议链接： ${tlcInfo.joinUrl || "无"}\n`}
${attendMode || cTlcNotice.detail}` || ""
}

export function joinMtInReactNative(tlcInfo) {
  // console.log(tlcInfo)
  try {
    window.ReactNativeWebView.postMessage(JSON.stringify({
      send_type: 'join_meeting_nemo',
      data: {
        meetingNumber: tlcInfo.conferenceNum + '',
        meetingPwd: tlcInfo.password
      }
    }))
  } catch (e) {
    // console.log(e.message);
    vtDialog.alert({
      title: "错误提示",
      message: e.message,
    }).then(() => {
      // on close
    })
  }
}

export function checkIsNeedReview(destData, dbMDoc) {
  if (dbMDoc && dbMDoc.mid) {
    // 时间变更，需重新审核
    if (destData.startTime !== dbMDoc.startTime || destData.endTime !== dbMDoc.endTime) return true;
    const [destRoom] = destData.meetingRooms || [];
    const [dbRoom = {}] = dbMDoc.meetingRooms || [];
    if (destRoom && destRoom.id) {
      // 会议室变更，需重新审核
      return destRoom.id !== dbRoom.roomId
    }
    return false
  }
  // 新建会议，需审核
  return true
}

export function checkReviewDiff(startTime, preReviewTime, room) {
  if (preReviewTime) {
    const minutes = moment(startTime).diff(moment(), 'm');
    // console.log(minutes);
    if (minutes < preReviewTime) {
      return `【${room.roomNum}】预约需审核，请至少提前${formatMinToNtcTime(preReviewTime)}预约`
    }
  }
}

// 判断显示权限
export function checkShowPermit(permissionList, permitKey) {
  if (permissionList.length) {
    return permissionList.includes(permitKey)
  }
  // 未设置，则全显示
  return true
}

// 判断是否可以提交服务需求
export function checkServicePermit(info) {
  const {reserveDoc, serviceSetting} = info || {};
  // 未选择会议室则不可提交服务
  if (!reserveDoc.room.roomNum) return false;
  // 选择的会议室不支持服务
  if (!reserveDoc.room.isServiceSupport) return false;
  // 系统不需要限制服务条件
  if (!serviceSetting.customerGrade) return true;
  // 重要客户
  if (reserveDoc.customerGrade >= serviceSetting.customerGrade) return true;
  // 重要内部参会人
  const importantMembers = serviceSetting.importantMembers || [];
  if (importantMembers.length) {
    if (importantMembers.includes('all')) return true;
    return reserveDoc.insideParticipant.some(e => importantMembers.includes(e.userId))
  }
  return false
}

// 组装
export function assembleDemandOptions(info) {
  const {reserveDoc, serviceSetting} = info || {};
  // 未选择会议室则不可提交服务
  if (!reserveDoc.room.roomNum) return [];
  // 选择的会议室不支持服务
  if (!reserveDoc.room.isServiceSupport) return [];
  const demandOptions = serviceSetting.demandOptions || [];
  // 重要组成员
  const importantMembers = serviceSetting.importantMembers || [];
  if (importantMembers.length) {
    if (importantMembers.includes('all')
      || reserveDoc.insideParticipant.some(e => importantMembers.includes(e.userId))) {
      return demandOptions;
    }
  }
  const grade = reserveDoc.customerGrade || 0;
  const roomLctIds = (reserveDoc.room.locationList || []).map(e => e.id);
  // console.log(roomLctIds)
  return demandOptions.filter(dm => {
    const gradePermit = !dm.grades || !dm.grades.length || dm.grades.some(g => g === 0 || g === Number(grade));
    const lctPermit = !dm.locationIds || !dm.locationIds.length || dm.locationIds.some(id => roomLctIds.includes(id));
    return gradePermit && lctPermit
  })
}

// 动态添加favicon
export function appendFavicon(url) {
  const icoUrl = url || (window.location.origin + '/favicon.ico');
  // console.log(icoUrl);
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = icoUrl;
  document.head.appendChild(link);
}

// 生成随机密码，6位
export function generateRandomPwd() {
  let pwd = ''
  for (let i = 0; i < 6; i++) {
    pwd += Math.floor(Math.random() * 10);
  }
  // const pwd = Math.floor(Math.random() * 1000000);
  // if (String(pwd).length < 6) return pwd * 10;
  return pwd
}

// call this
export function checkTsExpired() {
  // console.log(this.$route.query);
  let ts = this.$route.query.ts;
  if (!ts || ts.length !== 13) return true;

  ts = Number(ts);
  if (Number.isNaN(ts)) return true;
  // 10分钟
  if (moment(new Date()).diff(moment(ts), 's') > 600) {
    this.expired = true;
    return true
  }
}

// 判断是 ReactNative 环境
export function checkIsReactNative() {
  // return true
  return window.ReactNativeWebView && window.ReactNativeWebView.postMessage && true
}

// 定制化的返回处理
export function customizedBackHdr(curPath) {
  const redirectRecord = getStorage(StorageKey.redirectRecord);
  if (redirectRecord && redirectRecord === curPath) {
    console.log('customizedBackHdr path:', curPath);
    // todo: 通用化
    if (checkIsReactNative()) {
      try {
        const jsonStr = JSON.stringify({'send_type': 'goBack'});
        window.ReactNativeWebView.postMessage(jsonStr);
        return true
      } catch (e) {
        vtToast(e.message)
      }
    }
  }
}

/**
 * 初始化jsbridge
 * @param readyCallback 初始化完成后的回调
 */
export function initWeiTalkJsBridge(readyCallback) {
  if (window.WebViewJavascriptBridge) {
    readyCallback();
    return;
  }
  const u = navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (!isAndroid && !isiOS) {
    readyCallback();
    return
  }

  // 注册jsbridge
  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid) {
      if (window.WebViewJavascriptBridge) {
        callback(WebViewJavascriptBridge)
      } else {
        document.addEventListener(
          'WebViewJavascriptBridgeReady',
          function () {
            callback(WebViewJavascriptBridge)
          },
          false
        );
      }
      return;
    }

    if (isiOS) {
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      const WVJBIframe = document.createElement('iframe');
      WVJBIframe.style.display = 'none';
      WVJBIframe.src = 'https://__bridge_loaded__';
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }
  }

  // 调用注册方法
  connectWebViewJavascriptBridge(function (bridge) {
    if (isAndroid) {
      bridge.init(function (message, responseCallback) {
        // console.log('JS got a message', message);
        responseCallback(data);
      });
    }
    bridge.registerHandler('jsbridge_showMessage', function (data, responseCallback) {
      // initFunc.showResponse(data);
    });
    bridge.registerHandler('jsbridge_getJsMessage', function (data, responseCallback) {
      // initFunc.showResponse(data);
      responseCallback('native 传过来的是：' + data);
    });
    readyCallback();
  });
}

// 从JsBridge中获取token
export function getTokenByJsBridge(cb) {
  try {
    initWeiTalkJsBridge(function () {
      if (!window.WebViewJavascriptBridge) {
        alert("initJsBridge failed.");
        cb && cb(null);
        return
      }
      window.WebViewJavascriptBridge.callHandler('getUserToken', {
        "apptag": "ezLink"
      }, function (response) {
        // alert(response);
        cb && cb(response);
      });
    })
  } catch (e) {
    console.log(e.message);
    alert(e.message);
  }
}

// 获取扩展字段的值
export function getExtensionFieldVal(cfg, data) {
  if (data.hasOwnProperty(cfg.key)) return data[cfg.key];
  if (cfg.isMulti) return [];
  // 单选组织架构用户，初始化为对象，接口提交时为userId
  if (cfg.setType === commonConfig.extFields.setTypes.structure) return {};

  switch (cfg.valType) {
    case commonConfig.extFields.valTypes.number:
      return 0;
    case commonConfig.extFields.valTypes.boolean:
      return false;
    case commonConfig.extFields.valTypes.string:
    default:
      return ""
  }
}

export function checkStaticFieldsVal(requiredCfg, data) {
  // console.log(data)
  return requiredCfg && Object.keys(requiredCfg).find(k => {
    if (Array.isArray(data[k])) {
      return !data[k].length
    } else if (typeof data[k] === 'object') {
      return !(data[k] && data[k].userId)  // 暂时只有人员相关必填处理
    }
    return !data[k]
  })
}

// 检查扩展字段的值
export function checkExtensionFieldVal(cfg, data) {
  const rs = {
    fail: false,
    val: data[cfg.key]
  };
  if (cfg.setType === commonConfig.extFields.setTypes.structure) {
    rs.val = cfg.isMulti ? (data[cfg.key] || []).map(e => e.userId) : (data[cfg.key] || {}).userId
  }
  if (cfg.isRequired) {
    if (cfg.isMulti) {
      if (!rs.val || !rs.val.length) rs.fail = true;
    } else {
      switch (cfg.valType) {
        case commonConfig.extFields.valTypes.number:
        case commonConfig.extFields.valTypes.boolean:
          if (!data.hasOwnProperty(cfg.key)) rs.fail = true;
          break;
        case commonConfig.extFields.valTypes.string:
        default:
          if (!rs.val) rs.fail = true;
      }
    }
  }
  // console.log(cfg.key, rs);
  return rs
}

// 校验视频会议密码
export function checkTlcPwd(tlcManufacturer, pwd) {
  const reg = tlcConfig.pwdCheckReg[tlcManufacturer] && tlcConfig.pwdCheckReg[tlcManufacturer].reg || commonConfig.numLetterReg;
  return reg.test(pwd);
}

export function base64ToBlob(code) {
  let parts = code.split(';base64,')
  let contentType = parts[0].split(':')[1]
  let raw = window.atob(parts[1])
  let rawLength = raw.length
  let uInt8Array = new Uint8Array(rawLength)
  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], {type: contentType})
}

// 判断是否是IE低版本浏览器
export function isIeLowVersion() {
  let userAgent = navigator.userAgent;
  let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
  if (isIE) {
    let reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    let iEVersion = parseFloat(RegExp["$1"]);
    if (iEVersion <= 10) {
      return true;
    }
  }
  return false;
}

// 获取周期会议重复次数
export function getPeriodicTimes(periodicType, untilDate, startDate) {
  let times = 1;
  const diffDays = moment(untilDate).startOf('d').diff(moment(startDate).startOf('d'), 'd');
  // console.log(diffDays)
  switch (periodicType) {
    case commonConfig.periodicTypes.daily.value:
      return diffDays + 1;
    case commonConfig.periodicTypes.weekdays.value: {
      const weekday = startDate.getDay();
      let idx = 0;
      times = 0;  // 归零
      while (idx <= diffDays) {
        if ((weekday + idx) % 7 % 6 !== 0) times++;
        idx++
      }
      return times;
    }
    case commonConfig.periodicTypes.weekly.value:
      return Math.floor(diffDays / 7) + 1;
    case commonConfig.periodicTypes.fortnightly.value:
      return Math.floor(diffDays / 14) + 1;
    case commonConfig.periodicTypes.monthly.value: {
      return moment(untilDate).startOf('d').diff(moment(startDate).startOf('d'), "month") + 1
    }
    default:
  }
  return times
}

//记录当前页面位置
export function savePagePosition(val) {
  if (val) {
    localStorage.setItem(val, window.scrollY) //离开路由时把位置存起来
  }
}

//清除当前记录位置
export function removePagePosition() {
  if (localStorage.getItem("reserve")) {
    localStorage.removeItem('reserve')
  }
  if (localStorage.getItem("meetingList")) {
    localStorage.removeItem('meetingList')
  }
  if (localStorage.getItem("roomList")) {
    localStorage.removeItem('roomList')
  }
}
